export function isPC(ua = navigator.userAgent): boolean {
  return !/(Android|webOS|iPhone|iPod|iPad|tablet|BlackBerry|Mobile)/i.test(ua)
}

// 获取assets静态资源
export const getAssetsFile = (url: string) => {
  return new URL(`../assets/img/${url}`, import.meta.url).href
}

export function isImgUrl(url?: string): boolean {
  if (!url || typeof url !== 'string') return false
  const extensions = ['.png', '.webp', '.jpg', '.gif']
  for (const e of extensions) {
    if (url?.endsWith(e)) return true
  }
  return false
}

/** 是否香港官网 */
export function isHKSite(): boolean {
  return location.hostname.includes('hkshangmi')
}
